export enum NumberFormatKinds {
  None = 0,
  Money = 1,
}
